import React, { useState } from 'react';
import logoImg from '../assest/logo.png';
import qrImg from '../assest/qr-code.png';
import signImg from '../assest/sighn.png';
import { createPortal } from 'react-dom';
import toast from 'react-hot-toast';

export default function EmployeeIDCardModal({ isOpen, onClose, employee }) {
  const [isFlipped, setIsFlipped] = useState(false);

  if (!isOpen || !employee) return null;

  const phone = employee.user?.phone || employee.phone || '+91 7483649276';
  const empId = employee.id || 'EMP-2026-5217';
  const joinDate = employee.joinDate || '12/01/2026';
  const department = employee.department || 'KYP';
  const name = employee.name || 'EMPLOYEE NAME';
  const role = employee.role || 'DESIGNATION';
  const photo = employee.avatar || employee.profile_photo_url
    || `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=cccccc&color=555555&bold=true&size=200`;

  return createPortal(
    <div style={{
      position: 'fixed', inset: 0, zIndex: 10000,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '16px',
      fontFamily: "'Roboto', sans-serif",
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700;900&display=swap');
        .kyp-backdrop { position:fixed;inset:0;background:rgba(40,50,65,0.88);backdrop-filter:blur(4px); }
        .kyp-close-btn { position:absolute;top:8px;right:-38px;background:none;border:none;color:rgba(255,255,255,0.8);cursor:pointer;line-height:1; }
        .kyp-close-btn:hover { color:#fff; }
        .kyp-dl-btn { display:flex;align-items:center;gap:8px;background:#d82828;color:#fff;border:none;
          padding:10px 28px;border-radius:6px;font-family:'Roboto',sans-serif;font-weight:900;
          font-size:13px;letter-spacing:0.04em;cursor:pointer;margin-top:10px; }
        .kyp-dl-btn:hover { background:#b91c1c; }
        .kyp-hint { color:rgba(255,255,255,0.55);font-size:11px;margin-top:2px;text-align:center;font-weight:500; }
      `}</style>

      {/* Backdrop */}
      <div className="kyp-backdrop" onClick={onClose} />

      {/* Wrapper */}
      <div style={{ position:'relative', display:'flex', flexDirection:'column', alignItems:'center', transform:'scale(0.88)', transformOrigin:'center' }}>

        {/* Close button */}
        <button className="kyp-close-btn" onClick={onClose} title="Close ID Card">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>

        {/* ==================== CARD ==================== */}
        <div
          onClick={() => setIsFlipped(!isFlipped)}
          style={{
            width: '310px',
            height: '475px',
            background: '#fff',
            borderRadius: '18px',
            border: '1.5px solid #fff',
            boxSizing: 'content-box',
            overflow: 'hidden',
            position: 'relative',
            cursor: 'pointer',
            boxShadow: '0 24px 60px rgba(0,0,0,0.45)',
            userSelect: 'none',
          }}
        >
          {/* ---- FRONT ---- */}
          <div style={{
            position: 'absolute', inset: 0,
            opacity: isFlipped ? 0 : 1,
            pointerEvents: isFlipped ? 'none' : 'auto',
            transition: 'opacity 0.4s',
          }}>

            {/* ---- Red Faceted Background (4-Line Geometry Design) ---- */}
            <div style={{ position:'absolute', top:0, left:0, width:'100%', height:'210px', zIndex:0, clipPath:'polygon(0 0, 100% 0, 100% 100%)', overflow:'hidden' }}>
                <div style={{ position:'absolute', inset:0, background:'linear-gradient(135deg, #ef2a30 0%, #b91318 100%)' }}></div>
                
                {/* Line 1: Center-Right dark facet (behind logo) */}
                <div style={{
                  position:'absolute', top:0, right:0, width:'100%', height:'100%',
                  backgroundColor:'#991b1b', opacity:0.4, mixBlendMode:'multiply',
                  clipPath:'polygon(30% 0px, 70% 0px, 100% 100%)'
                }}></div>

                {/* Line 2: Glint on top center */}
                <div style={{
                  position:'absolute', top:0, right:0, width:'100%', height:'100%',
                  backgroundColor:'white', opacity:0.15,
                  clipPath:'polygon(20% 0px, 80% 0px, 50% 25%)'
                }}></div>

                {/* Line 3: Left Shadow facet to define the 3D cut */}
                <div style={{
                  position:'absolute', top:0, left:0, width:'100%', height:'100%',
                  backgroundColor:'black', opacity:0.1,
                  clipPath:'polygon(0 0, 30% 0px, 60% 100%, 0 100%)'
                }}></div>

                {/* 2 lines from Top-Left to Right-Center to complete barfi geometry with whiteness */}
                <div style={{
                  position:'absolute', top:0, left:0, width:'100%', height:'100%',
                  backgroundColor:'white', opacity:0.1,
                  clipPath:'polygon(0 0, 40% 0px, 100% 80%, 100% 100%)'
                }}></div>

                <div style={{
                  position:'absolute', top:0, left:0, width:'100%', height:'100%',
                  backgroundColor:'white', opacity:0.04,
                  clipPath:'polygon(0 0, 50% 0px, 100% 60%, 100% 100%)'
                }}></div>
            </div>

            {/* Logo circle - top right */}
            <div style={{
              position:'absolute', top:'12px', right:'12px',
              display:'flex', flexDirection:'column', alignItems:'center', gap:'3px',
              zIndex: 10,
            }}>
              <div style={{
                width:'48px', height:'48px', borderRadius:'50%',
                background:'#fff', boxShadow:'0 2px 8px rgba(0,0,0,0.18)',
                display:'flex', alignItems:'center', justifyContent:'center', padding:'5px',
              }}>
                <img
                  src={logoImg}
                  alt="Logo"
                  style={{ width:'32px', height:'32px', objectFit:'contain' }}
                />
              </div>
              <div style={{ textAlign:'center' }}>
                <div style={{
                  color:'#fff', fontWeight:900, fontSize:'10px',
                  letterSpacing:'0.08em', lineHeight:1.1,
                }}>SECURE INSIGHT</div>
                <div style={{
                  color:'rgba(255,255,255,0.85)', fontWeight:700,
                  fontSize:'6.5px', letterSpacing:'0.12em',
                  display:'flex', alignItems:'center', gap:'3px', justifyContent:'center',
                }}>
                  <span>——</span>
                  <span>FOREVER PVT. LTD.</span>
                  <span>——</span>
                </div>
              </div>
            </div>

            {/* ---- Profile Photo (overlapping header and body) ---- */}
            <div style={{
              position:'absolute', top:'52px', left:'50%', transform:'translateX(-50%)',
              zIndex: 20,
            }}>
              <div style={{
                width:'96px', height:'96px', borderRadius:'50%',
                border:'3.5px solid #e8191f',
                padding:'3.5px', background:'#fff',
                boxShadow:'0 4px 16px rgba(0,0,0,0.3)',
              }}>
                <img
                  src={photo}
                  alt={name}
                  style={{ width:'100%', height:'100%', borderRadius:'50%', objectFit:'cover' }}
                />
              </div>
            </div>

            {/* ---- Name & Role ---- */}
            <div style={{
              position:'absolute', top:'170px', width:'100%',
              textAlign:'center', padding:'0 16px',
            }}>
              <div style={{
                fontFamily:'"Roboto", sans-serif', fontWeight:900, fontSize:'18px',
                color:'#111827', letterSpacing:'0.04em', textTransform:'uppercase', lineHeight:1.1,
              }}>{name}</div>
              <div style={{
                fontWeight: 800, fontSize:'10.5px', color:'#e8191f',
                letterSpacing:'0.22em', textTransform:'uppercase', marginTop:'5px',
              }}>{role}</div>
            </div>

            {/* ---- Info Rows ---- */}
            <div style={{
              position:'absolute', top:'228px', width:'100%',
              display:'flex', flexDirection:'column', alignItems:'center', gap:'6px',
            }}>
              {[
                { label: 'EMPLOYEE ID', value: empId },
                { label: 'PHONE NO', value: phone.replace('+91 ', '') },
                { label: 'JOINING DATE', value: joinDate },
                { label: 'DEPARTMENT', value: department },
              ].map((row, i) => (
                <div key={i} style={{ display:'grid', gridTemplateColumns:'95px 15px 95px', alignItems:'baseline', justifyContent:'center' }}>
                  <span style={{
                    fontWeight:700, fontSize:'9.5px', color:'#64748b',
                    letterSpacing:'0.08em', textTransform:'uppercase', textAlign:'left',
                  }}>{row.label}</span>
                  <span style={{ fontWeight:900, fontSize:'14px', color:'#334155', textAlign:'center' }}>:</span>
                  <span style={{
                    fontWeight:900, fontSize:'13.5px', color:'#1e293b',
                    textTransform: i < 2 ? 'none':'uppercase',
                    letterSpacing:'0.02em', whiteSpace:'nowrap', textAlign:'left',
                  }}>{row.value}</span>
                </div>
              ))}
            </div>

            {/* ---- Dotted Divider ---- */}
            <div style={{
              position:'absolute', top:'364px', left:'26px', right:'26px',
              borderTop:'2.5px dotted #cbd5e1',
            }} />

            {/* ---- Company Footer Row ---- */}
            <div style={{
              position:'absolute', top:'370px', left:'22px', right:'22px',
              display:'flex', alignItems:'center', gap:'10px',
            }}>
              {/* QR */}
              <div style={{
                width:'52px', height:'52px', flexShrink:0,
                border:'1px solid #f1f5f9', borderRadius:'6px',
                padding:'2px', background:'#fff',
                boxShadow:'0 2px 6px rgba(0,0,0,0.05)',
              }}>
                <img
                  src={qrImg}
                  alt="QR"
                  style={{ width:'100%', height:'100%', objectFit:'contain', borderRadius:'4px' }}
                />
              </div>

              {/* Company text */}
              <div style={{ flex:1, display:'flex', flexDirection:'column', gap:'4px' }}>
                <div style={{
                  fontWeight:900, fontSize:'9.5px', color:'#1e293b',
                  letterSpacing:'0.04em', textTransform:'uppercase',
                }}>SECURE INSIGHT FOREVER PVT. LTD.</div>
                
                <div style={{ display:'flex', alignItems:'center', gap:'4px' }}>
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#e8191f" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                  <span style={{ fontSize:'7.5px', fontWeight:700, color:'#64748b' }}>
                    Mahesh Nagar Patna (Bihar) 800024
                  </span>
                </div>
                
                <div style={{ display:'flex', alignItems:'center', gap:'8px' }}>
                  <div style={{ display:'flex', alignItems:'center', gap:'4px' }}>
                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#e8191f" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>
                    <span style={{ fontSize:'7px', fontWeight:700, color:'#64748b' }}>www.secureinsights.in</span>
                  </div>
                  <div style={{ display:'flex', alignItems:'center', gap:'4px' }}>
                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#e8191f" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                    <span style={{ fontSize:'7px', fontWeight:700, color:'#64748b' }}>info@secureinsights.com</span>
                  </div>
                </div>
              </div>
            </div>            {/* ---- Bottom Black Bar (Phone Contact) ---- */}
            <div style={{
              position:'absolute', bottom:0, left:0, right:0, height:'42px',
              background:'#111827',
              display:'flex', alignItems:'center', justifyContent:'center', gap:'8px',
              borderRadius:'0 0 18px 18px',
              zIndex: 30,
            }}>
              {/* Left red accent */}
              <div style={{
                position:'absolute', left:0, top:0, bottom:0, width:'6px',
                background:'#e8191f', borderRadius:'0 0 0 18px',
              }} />
              <svg width="14" height="14" viewBox="0 0 24 24" fill="#e8191f" style={{flexShrink:0}}>
                <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
              </svg>
              <span style={{
                color:'#fff', fontWeight:900, fontSize:'13.5px', letterSpacing:'0.08em',
              }}>+91 7483649276</span>
            </div>

          </div>

          {/* ---- BACK ---- */}
          <div style={{
            position:'absolute', inset:0, background:'#fff',
            opacity: isFlipped ? 1 : 0,
            pointerEvents: isFlipped ? 'auto' : 'none',
            transition: 'opacity 0.4s',
            borderRadius:'18px',
            overflow:'hidden',
            display:'flex', flexDirection:'column',
          }}>
            {/* Back Red Header swoosh using exact 4-line geometry */ }
            <div style={{ position:'relative', width:'100%', height:'210px', flexShrink:0, overflow:'hidden' }}>
              <div style={{ position:'absolute', top:0, left:0, width:'100%', height:'100%', zIndex:0, overflow:'hidden', clipPath:'polygon(0 0, 100% 0, 100% 100%)' }}>
                <div style={{ position:'absolute', inset:0, background:'linear-gradient(135deg, #ef2a30 0%, #b91318 100%)' }}></div>
                
                <div style={{
                  position:'absolute', top:0, right:0, width:'100%', height:'100%',
                  backgroundColor:'#991b1b', opacity:0.4, mixBlendMode:'multiply',
                  clipPath:'polygon(30% 0px, 70% 0px, 100% 100%)'
                }}></div>

                <div style={{
                  position:'absolute', top:0, right:0, width:'100%', height:'100%',
                  backgroundColor:'white', opacity:0.15,
                  clipPath:'polygon(20% 0px, 80% 0px, 50% 25%)'
                }}></div>

                <div style={{
                  position:'absolute', top:0, left:0, width:'100%', height:'100%',
                  backgroundColor:'black', opacity:0.1,
                  clipPath:'polygon(0 0, 30% 0px, 60% 100%, 0 100%)'
                }}></div>

                <div style={{
                  position:'absolute', top:0, left:0, width:'100%', height:'100%',
                  backgroundColor:'white', opacity:0.1,
                  clipPath:'polygon(0 0, 40% 0px, 100% 80%, 100% 100%)'
                }}></div>

                <div style={{
                  position:'absolute', top:0, left:0, width:'100%', height:'100%',
                  backgroundColor:'white', opacity:0.04,
                  clipPath:'polygon(0 0, 50% 0px, 100% 60%, 100% 100%)'
                }}></div>
              </div>
            </div>

            {/* Centered Logo Circle - overlapping bottom of header */}
            <div style={{
              position:'absolute', top:'58px', left:'50%', transform:'translateX(-50%)',
              width:'95px', height:'95px', borderRadius:'50%',
              background:'#fff', boxShadow:'0 4px 16px rgba(0,0,0,0.18)',
              display:'flex', alignItems:'center', justifyContent:'center',
              padding:'8px', zIndex:10,
            }}>
              <img src={logoImg} alt="Logo" style={{ width:'68px', height:'68px', objectFit:'contain' }} />
            </div>

            {/* Back Body */}
            <div style={{ flex:1, display:'flex', flexDirection:'column', alignItems:'center', padding:'5px 23px 10px' }}>
              {/* Company Name */}
              <div style={{ fontWeight:900, fontSize:'18px', color:'#1e293b', letterSpacing:'0.06em', textTransform:'uppercase', textAlign:'center', lineHeight:1.1 }}>
                SECURE INSIGHT
              </div>
              {/* Sub line with red dashes */}
              <div style={{ display:'flex', alignItems:'center', gap:'6px', marginTop:'5px' }}>
                <div style={{ height:'1.5px', width:'18px', background:'#e8191f' }} />
                <div style={{ fontWeight:700, fontSize:'9px', color:'#e8191f', letterSpacing:'0.2em', textTransform:'uppercase' }}>FOREVER PVT. LTD.</div>
                <div style={{ height:'1.5px', width:'18px', background:'#e8191f' }} />
              </div>

              {/* Terms & Conditions Box */}
              <div style={{
                width:'100%', marginTop:'12px',
                border:'1px solid #e2e8f0', borderRadius:'4px',
                padding:'10px 12px 10px 16px', background:'#f8fafc', textAlign:'left',
                position: 'relative', overflow: 'hidden'
              }}>
                {/* Red accent strip */}
                <div style={{ position:'absolute', left:0, top:0, bottom:0, width:'3px', background:'#e8191f' }} />
                <div style={{ fontWeight:900, fontSize:'9.5px', color:'#1e293b', letterSpacing:'0.1em', textTransform:'uppercase', marginBottom:'8px' }}>
                  TERMS &amp; CONDITIONS
                </div>
                <ul style={{ margin:0, padding:'0 0 0 13px', display:'flex', flexDirection:'column', gap:'5px' }}>
                  {[
                    'This card is the property of Secure Insights.',
                    'Card is non-transferable & official use only.',
                    'Report loss immediately to HR Dept.',
                    'Surrender this card upon termination.',
                  ].map((t, i) => (
                    <li key={i} style={{ fontSize:'9.2px', fontWeight:600, color:'#475569', lineHeight:1.4 }}>{t}</li>
                  ))}
                </ul>
              </div>

              {/* Signature Section */}
              <div style={{
                width:'100%', marginTop:'auto', paddingTop:'15px',
                display:'flex', alignItems:'flex-end', justifyContent:'space-between',
                paddingBottom: '5px'
              }}>
                {/* Authorized Signature */}
                <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'3px' }}>
                  <img src={signImg} alt="Authorized Signature"
                    style={{ width:'65px', height:'28px', objectFit:'contain' }}
                  />
                  <div style={{ height:'1.2px', width:'75px', background:'#e8191f' }} />
                  <div style={{ fontWeight:800, fontSize:'6px', color:'#e8191f', letterSpacing:'0.05em', textTransform:'uppercase', marginTop:'2px' }}>AUTHORIZED SIGNATURE</div>
                </div>

                {/* Holder Signature */}
                <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'3px' }}>
                  <div style={{
                    fontFamily:"'Dancing Script', cursive",
                    fontSize:'14px', color:'#1e293b', fontWeight: 600,
                    lineHeight:1.2, paddingBottom:'2px', whiteSpace:'nowrap',
                  }}>{name}</div>
                  <div style={{ height:'1.2px', width:'75px', background:'#e8191f' }} />
                  <div style={{ fontWeight:800, fontSize:'6px', color:'#e8191f', letterSpacing:'0.05em', textTransform:'uppercase', marginTop:'2px' }}>HOLDER SIGNATURE</div>
                </div>
              </div>

            </div>
          </div>

        </div>
        {/* ==================== END CARD ==================== */}

        {/* Hint text */}
        <p className="kyp-hint">Touch card to view back side</p>

        {/* Download button */}
        <button className="kyp-dl-btn" onClick={(e) => { e.stopPropagation(); toast.success('Preparing ID Card for download...'); }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
            <polyline points="7 10 12 15 17 10"/>
            <line x1="12" y1="15" x2="12" y2="3"/>
          </svg>
          Download ID Card
        </button>

      </div>
    </div>,
    document.body
  );
}
